import { useState, useEffect } from 'react'
import { useAuth } from '../context/AuthContext'
import { supabase } from '../lib/supabase'

export const usePermiso = (modulo, permiso = 'ver') => {
  const { user } = useAuth()
  const [tienePermiso, setTienePermiso] = useState(false)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!user) { setLoading(false); return }
    
    const verificarPermiso = async () => {
      try {
        // Obtener el rol del voluntario
        const { data: voluntario } = await supabase
          .from('voluntarios')
          .select('rol')
          .eq('auth_id', user.id)
          .single()
        
        if (!voluntario) { setLoading(false); return }
        
        // Admin tiene todos los permisos
        if (voluntario.rol === 'admin') {
          setTienePermiso(true)
          setLoading(false)
          return
        }
        
        // Verificar si tiene el permiso específico
        const { data } = await supabase
          .from('permisos_roles')
          .select('id')
          .eq('rol', voluntario.rol)
          .eq('modulo', modulo)
          .eq('permiso', permiso)
          .eq('activo', true)
          .maybeSingle()
        
        setTienePermiso(!!data)
      } catch (error) {
        console.error('Error verificando permiso:', error)
        setTienePermiso(false)
      } finally {
        setLoading(false)
      }
    }
    
    verificarPermiso()
  }, [user, modulo, permiso])

  return { tienePermiso, loading }
}